/**Representante de cliente en reclamo */
export class ComplaintClientRepresentative {
    /**Nombre */
    public name: string;
    /**Apellidos */
    public lastName: string;
    /**Tipo de documento */
    public documentType: string;
    /**Número de documento */
    public documentNumber: string;
    /**Teléfono fijo */
    public homePhone: string;
    /**Celular */
    public cellPhone: string;
    /**Correo electrónico */
    public emailAddress: string;
    /**Tipo de relación de representante con el cliente */
    public relationshipType: string;
}